export default __webpack_public_path__ + "static/media/grill-change.fa8bb7ac.svg";